import { render, staticRenderFns } from "./SalonEditar.vue?vue&type=template&id=fb857a84&"
import script from "./SalonEditar.vue?vue&type=script&lang=js&"
export * from "./SalonEditar.vue?vue&type=script&lang=js&"
import style0 from "./SalonEditar.vue?vue&type=style&index=0&id=fb857a84&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports